import { Stack, useNavigationContainerRef } from 'expo-router';
import { useDrawerType } from 'hooks/useDrawerType';
import { strings } from 'strings';

export default function Layout() {
  const drawerType = useDrawerType();

  const containerRef = useNavigationContainerRef();

  const headerShown =
    drawerType !== 'permanent' && !!containerRef.getCurrentRoute()?.params;

  return (
    <Stack
      screenOptions={{
        headerShown,
        headerTitle: strings.ButtonTextBack,
      }}
    />
  );
}
